/**
 * Centralized API configuration.
 * Single source of truth for API base URL and endpoints.
 */

const getApiBase = () => {
  const envBase = process.env.REACT_APP_API_BASE;
  if (envBase) {
    // Normalize env base: fix 127.0.0.1 and strip any trailing slashes
    return envBase
      .replace('127.0.0.1', 'localhost')
      .replace(/\/+$/, '');
  }
  // In development, use relative URL so CRA proxy forwards to backend (avoids CORS)
  if (process.env.NODE_ENV === 'development') {
    return '';
  }
  return 'http://localhost:8000';
};

export const API_BASE = getApiBase();

export const API_ENDPOINTS = {
  login: `${API_BASE}/auth/login`,
  logout: `${API_BASE}/auth/logout`,
  me: `${API_BASE}/auth/me`,

  users: `${API_BASE}/api/users/`,
  salespeople: `${API_BASE}/api/salespeople`,

  dashboardBundle: `${API_BASE}/api/metrics/dashboard-bundle`,
  monthlyPerformance: `${API_BASE}/api/metrics/monthly-performance`,
  closedLostMonthly: `${API_BASE}/api/metrics/closed-lost-monthly`,
  goodBadPairs: `${API_BASE}/api/metrics/good-bad-margin-pairs`,
  topCompanies: `${API_BASE}/api/metrics/top-companies`,
  pipelineOverview: `${API_BASE}/api/metrics/pipeline-overview`,
  probabilityAnalysis: `${API_BASE}/api/metrics/probability-analysis`,
  focSamples: `${API_BASE}/api/metrics/foc-samples`,
  forecastedBooking: `${API_BASE}/api/metrics/forecasted-booking`,
  yearlySales: `${API_BASE}/api/sales/yearly`,

  closedLostReasons: `${API_BASE}/closed-lost/reasons`,

  aiChat: `${API_BASE}/ai/chat`,
  detectAnomalies: `${API_BASE}/ai/detect-anomalies`,
  anomalyDashboard: `${API_BASE}/ai/anomaly-dashboard`,

  validateTotal: `${API_BASE}/api/metrics/validate-total`,

  health: `${API_BASE}/api/health`,

  opps: `${API_BASE}/api/opps`,
  oppDetail: (code) => `${API_BASE}/api/opps/${code}`,
  filtersMeta: `${API_BASE}/api/meta/filters`,
};
